import { ErrorHandler } from "./screens/ErrorHandler";
import { AppAlertBox } from "./components/dialogue/AppAlertBox";
import { Providers } from "./redux/provider";
import { NavBar } from "./components";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <Providers>
      <AppAlertBox />
      <ErrorHandler />
      <NavBar />
      <AppRoutes />
      <ToastContainer position="top-center" autoClose={3000} theme="colored" />
    </Providers>
  );
}

export default App;
